export default `
§ page.settings.document.title: Display settings
§ page.settings.document.name: Page title
§ page.settings.document.language: Interface language
§ page.settings.links.title: Link prefixes
§ page.settings.links.task: For task numbers
§ page.settings.links.pr: For PR
§ page.settings.user.title: Individual settings
§ page.settings.user.notFound: No individual settings. Data for all employees are calculated based on common parameters.
§ page.settings.user.subTitle: Addendum to employment contract №$1
§ page.settings.user.from: Start date
§ page.settings.mailmap: .mailmap example
§ page.settings.common.title: General salary data
§ page.settings.common.type.title: Project work type
§ page.settings.common.type.full: Full-time employment
§ page.settings.common.type.part: Project work
§ page.settings.common.salary: Monthly salary
§ page.settings.common.currency: Currency
§ page.settings.common.workDaysInYear: Number of working days in a year
§ page.settings.common.vacationDaysInYear: Number of vacation days in a year
§ page.settings.common.workDaysInWeek: Workdays
§ page.settings.form.save: Save
§ page.settings.form.cancel: Cancel
§ page.settings.form.remove: Remove
§ page.settings.form.addEmployee: Add an employee
§ page.settings.form.addContract: Add an employment contract
`;